import { makeAutoObservable, runInAction } from 'mobx';
import msToHumanTime from 'helpers/ms-to-human-time';
import AlertStore from './Alert';
import goxApi from 'api/gox-api';

class Ride {

  id = null;
  scooterId = null;
  createdAt = null;
  completedAt = null;
  pricingModel = null;
  startedAt = null;
  rideTime = 0;
  rideDistance = 0;
  tracks = [];
  turboStatus = 'disabled';
  rideCost = 0;
  status = null;
  currentTime = null;
  vehicleModel = null;
  pricingPlan = {};
  organizationInfo = null;
  parkingFee = null;
  rideHold = [];
  completing = false;

  constructor({
    id,
    scooter_id,
    created_at,
    completed_at,
    pricing_model,
    started_at,
    ride_time,
    ride_distance,
    ride_tracks,
    turbo_status,
    ride_cost,
    status,
    current_time,
    vehicle_model,
    pricing_plan,
    organization_info,
    parking_fee,
    ride_hold
  }) {
    this.id = id;
    this.scooterId = scooter_id;
    this.createdAt = created_at;
    this.completedAt = completed_at;
    this.pricingModel = pricing_model;
    this.startedAt = started_at;
    this.rideTime = ride_time;
    this.rideDistance = ride_distance;
    this.tracks = ride_tracks;
    this.turboStatus = turbo_status;
    this.rideCost = ride_cost;
    this.status = status;
    this.currentTime = current_time;
    this.vehicleModel = vehicle_model;
    this.pricingPlan = pricing_plan;
    this.organizationInfo = organization_info;
    this.parkingFee = parking_fee;
    this.rideHold = ride_hold;

    makeAutoObservable(this);
  }

  get duration() {
    return new Date().getTime() - new Date(this.createdAt).getTime() ?? 0;
  }

  get battery() {
    return this.rideTracks?.[this.rideTracks.length - 1]?.battery ?? 100;
  }

  get time() {
    return msToHumanTime(this.duration) ?? 0;
  }

  async toggleTurboMode(command) {
    try {
      await goxApi.turboMode(this.id, command);
      runInAction(() => {
        this.turboStatus = command === 'enable' ? 'enabled' : 'disabled';
      });
    } catch (err) {
      AlertStore.add(err.message);
    }
  }

  async complete() {
    try { 
      this.completing = true;
      await goxApi.rideComplete(this.id);
      runInAction(() => {
        this.completing = false;
      });
    } catch (err) {
      AlertStore.add(err.message);
      runInAction(() => {
        this.completing = false;
      });
    }
  }
  
}


export default Ride;
